/**
 * converts the return value from blockly field to a boolean value
 * @param {string} value
 */
function convertToBoolean(value) {
    return /^true$/i.test(value);
}

module.exports = convertToBoolean;
